import Login from "./Login.component";

export default Login;
